export * from "./atoms";
export * from "./organisms";

import { DepartmentGroupAtoms } from "./atoms";
import { DepartmentGroupOrganisms } from "./organisms";

export const DepartmentGroupComponents = [...DepartmentGroupAtoms, ...DepartmentGroupOrganisms];
